import FIELD_OPTIONS from '../../../constants/field_options.constats';
import _EVENTS from '../../../constants/artifacts_events.constants';
import { REPO_FORM_CONSTANTS } from './repository_form.constants';

export class AdminRepositoriesController {
    constructor($scope, $q, RepositoriesDao, $stateParams, $state, JFrogTableViewOptions, commonGridColumns,
                ArtifactoryFeatures, JFrogEventBus, $timeout, JFrogModal, ArtifactActionsDao, GlobalReplicationsConfigDao) {
        this.$scope = $scope;
        this.$q = $q;
        this.$timeout = $timeout;
        this.repositoriesDao = RepositoriesDao;
        this.JFrogTableViewOptions = JFrogTableViewOptions;
        this.commonGridColumns = commonGridColumns;
        this.features = ArtifactoryFeatures;
        this.state = $state;
        this.$stateParams = $stateParams;
        this.JFrogEventBus = JFrogEventBus;
        this.modal = JFrogModal;
        this.EVENTS = JFrogEventBus.getEventsDefinition();
        this.artifactActionsDao = ArtifactActionsDao;
        this.globalReplicationsConfigDao = GlobalReplicationsConfigDao;

        this.stateRepoType = null;

        this.repositoriesTypes = ['local', 'remote', 'virtual', 'distribution'];
        this.currentRepoType = this.$stateParams.repoType;

        if (_.isEmpty(this.currentRepoType)) {
            this.state.go('admin.repositories.list', { repoType: 'local' });
        } else if (!_.includes(this.repositoriesTypes, this.currentRepoType)) {
            this.state.go('not_found_404');
        }

        this.repos = {};

        this.initRepos();
        this._getGlobalReplicationsStatus();

        this.wizardConfig = {}; //enableNgShow: true

        this.JFrogEventBus.registerOnScope(this.$scope, _EVENTS.REFRESH_REPOS_LIST, () => {
            this.initRepos();
        });


    }


    initRepos() {
        const getRepos = (type) => {
            let deferred = this.$q.defer();
            this.repositoriesDao.getRepositories({ type }).$promise
                .then((data) => {
                    this.repos[type] = data;
                    deferred.resolve();
                });
            return deferred.promise;
        };

        let allTypesPromisses = [];
        this.repositoriesTypes.forEach(type => allTypesPromisses.push(getRepos(type)));

        // promise all repositories data
        this.$q.all(allTypesPromisses).then(() => {

            let repoType;
            for (repoType in this.repos) {
                _.forEach(this.repos[repoType], row => {

                    let rowPackageType = _.find(FIELD_OPTIONS.repoPackageTypes, (type) => {
                        return type.value === row.repoType.toLowerCase();
                    });
                    if (rowPackageType) {

                        row.displayType = rowPackageType.text;
                        row.typeIcon = rowPackageType.icon;

                    } else if (row.repoType === REPO_FORM_CONSTANTS.DISTRIBUTION_REPO_TYPES.RELEASE_BUNDLES ||
                        row.repoType.toLowerCase() === FIELD_OPTIONS.REPO_TYPE.DISTRIBUTION) {


                        if (row.repoType === 'ReleaseBundles') {
                            row.displayType = 'Release Bundles';
                        }

                    } else {
                        row.ignore = true;
                    }
                });

                _.filter(this.repos[repoType], row => !row.ignore);

            }
            this.setupTables();
            this.stateRepoType = this.$stateParams.repoType.charAt(0).toUpperCase() + this.$stateParams.repoType.slice(1);

        });
    }

    onTabSwitch(tab) {
        this.currentRepoType = tab.toLowerCase();
        this.state.go('.', { repoType: this.currentRepoType }, { notify: false });
    }

    setupTables() {
        // Create local table
        this.localRepositoriesTable = {};
        this.localRepositoriesTable = new this.JFrogTableViewOptions(this.$scope);
        this.localRepositoriesTable.setId('local')
            .setObjectName('Repository/Repositories')
            .setColumns(this.getColumns('local'))
            .setEmptyTableText('No local repositories')
            .setNewEntityAction(() => this.createNewRepo());
        this.localRepositoriesTable.newEntityCustomText = 'New Local Repository';
        this.localRepositoriesTable.setData(this.repos.local);

        // Create remote table
        this.remoteRepositoriesTable = {};
        this.remoteRepositoriesTable = new this.JFrogTableViewOptions(this.$scope);
        this.remoteRepositoriesTable.setId('remote')
            .setObjectName('Repository/Repositories')
            .setColumns(this.getColumns('remote'))
            .setEmptyTableText('No remote repositories')
            .setNewEntityAction(() => this.createNewRepo());
        this.remoteRepositoriesTable.newEntityCustomText = 'New Remote Repository';
        this.remoteRepositoriesTable.setData(this.repos.remote);

        // Create virtual table
        this.virtualRepositoriesTable = {};
        this.virtualRepositoriesTable = new this.JFrogTableViewOptions(this.$scope);
        this.virtualRepositoriesTable.setId('virtual')
            .setObjectName('Repository/Repositories')
            .setColumns(this.getColumns('virtual'))
            .setEmptyTableText('No virtual repositories')
            .setNewEntityAction(() => this.createNewRepo());
        this.virtualRepositoriesTable.newEntityCustomText = 'New Virtual Repository';
        this.virtualRepositoriesTable.setData(this.repos.virtual);
        // Create distribution table
        this.distributionRepositoriesTable = {};
        this.distributionRepositoriesTable = new this.JFrogTableViewOptions(this.$scope);
        this.distributionRepositoriesTable.setId('distribution')
            .setObjectName('Repository/Repositories')
            .setColumns(this.getColumns('distribution'))
            .setEmptyTableText('No distribution repositories');
        this.distributionRepositoriesTable.setData(this.repos.distribution);


    }

    _calculateIndex(row) {
        this.artifactActionsDao.perform({
            action: 'calculateIndex',
            type: row.repoType,
            repoKey: row.repoKey,
        });
    }

    localReplicationsRunNow(repoKey) {
        this.repositoriesDao.runNowReplications({ repoKey: repoKey }).$promise.then(() => {
        });
    }

    remoteExecuteReplicationNow(repoKey) {
        this.repositoriesDao.executeRemoteReplicationNow({ repoKey: repoKey },
            this.repoInfo).$promise.then((result) => {

        });
    }

    ExecuteReplicationNow(repo) {
        const repoKey = repo.repoKey;
        if (repo.hasEnabledReplication) {
            this.remoteExecuteReplicationNow(repoKey);
        } else if (repo.replications) {
            this.localReplicationsRunNow(repoKey);
        }
    }

    _getGlobalReplicationsStatus() {
        this.globalReplicationsConfigDao.status().$promise.then((status) => {
            this.globalReplicationsStatus = {
                blockPullReplications: status.blockPullReplications,
                blockPushReplications: status.blockPushReplications,
            };
        });
    }

    createNewRepo(distRepoType) {
        this.state.go('^.list.new', { repoType: this.currentRepoType, distRepoType: distRepoType });
    }

    getColumns(type) {

        let linkParams = type === 'distribution' ?
            `repoType: '${type}', repoKey: row.entity.repoKey, distRepoType: row.entity.repoType` :
            `repoType: '${type}', repoKey: row.entity.repoKey`;

        let basic = [
            {
                header: 'Repository Key',
                field: 'repoKey',
                cellTemplate: `<div class="ui-grid-cell-contents">
                                <a class="jf-link"
                                   ui-sref="admin.repositories.list.edit({${linkParams}})"
                                   id="repositories-${type}-key">{{COL_FIELD}}</a></div>`,
                width: '50%',
                actions: {
                    delete: row => this._deleteSelected(row),
                },
            },
            {
                header: 'Type',
                displayName: 'Type',
                field: 'displayType',
                cellTemplate: this.commonGridColumns.iconColumn('row.entity.displayType', 'row.entity.typeIcon',
                    'repo-type-icon'),
                width: '15%',
            },
        ];
        const recalculateIndex = {
            header: 'Recalculate Index',
            field: 'reindex',
            textAlign: 'center',
            cellTemplate: '<div class="ui-grid-cell-contents text-center"><a class="table-view-column-button icon icon-re-index"' +
                ' ng-click="!row.entity.hasReindexAction || grid.appScope.Repositories._calculateIndex(row.entity)"' +
                ' ng-disabled="!row.entity.hasReindexAction" jf-tooltip="{{row.entity.hasReindexAction ? \'Recalculate Index Now\' : \'Recalculate Not Supported For Repo Type\'}}" id="repositories-local-reindex"></a></div>',
            width: '150px',
            sortable: false,
        };
        const replication = {
            header: 'Replications',
            field: 'replications',
            textAlign: 'center',
            cellTemplate: `<div class="ui-grid-cell-contents text-center"
                                ng-class="{\'replication-disabled\': grid.appScope.Repositories.globalReplicationsStatus.blockPushReplications}">
                                <a class="table-view-column-button icon icon-run"
                                    ng-click="grid.appScope.Repositories.ExecuteReplicationNow(row.entity)"
                                    ng-disabled="!row.entity.hasEnabledReplication && !row.entity.replications"
                                    jf-tooltip="{{grid.appScope.Repositories.globalReplicationsStatus.blockPushReplications ? \'Push Replication Is Blocked\' : (row.entity.replications ? \'Run Replication\' : \'No Replication Configured\')}}"
                                    id="repositories-local-replicate"></a>
                            </div>`,
            width: '100px',
            sortable: false,
        };

        switch (type) {
            case 'local':
                return [...basic, recalculateIndex, replication];
            case 'remote':
                const url = {
                    header: 'URL',
                    field: 'url',
                    width: '40%',
                };
                return [...basic, url, recalculateIndex, replication];
            case 'virtual':
                const selectedRepos = {
                    header: 'Selected Repositories',
                    field: 'selectedRepos',
                    cellTemplate: this.commonGridColumns.listableColumn('row.entity.selectedRepos',
                        'row.entity.repoKey', null, null, 'repositories-virtual-selected'),
                    width: '40%',
                    sortable: false,
                };
                return [...basic, selectedRepos, recalculateIndex];
            case 'distribution':

                const repoVisibility = {
                    header: 'Repository Visibility',
                    field: 'visibility',
                    cellTemplate: `<div class="ui-grid-cell-contents" id="repository-visibility">{{row.entity.visibility}}</div>`,
                    width: '20%',
                };

                const copy = [...basic];
                copy[1].cellTemplate = `<div class="ui-grid-cell-contents">{{row.entity.repoType}}</div>`;

                return [...copy, repoVisibility];
            default:
                return basic;

        }
    }

    _deleteSelected(row) {
        this.modal.confirm('Are you sure you wish to delete this repository? All artifacts will be permanently deleted.', 'Delete ' + row.repoKey + ' Repository', { confirm: 'Delete' })
            .then(() => {
                this.repositoriesDao.deleteRepository({
                    type: this.currentRepoType,
                    repoKey: row.repoKey,
                }).$promise.then((result) => {
                    this.initRepos();
                });
            });
    }

    // New Distribution Repo Actions Dropdown setup
    setQuickActions() {
        if (!this.quickActions) {
            return;
        }
        this.quickActions.setActionsDictionary(this.getActionsDictionary());
        this.quickActions.setActions(this.getActions());
    }

    initActionsDropdown(actionsController) {
        this.quickActions = actionsController;
        this.setQuickActions();
    }

    getActionsDictionary() {
        let dictionary = {};
        dictionary.newReleaseBundlesRepo = { title: 'New Release Bundles Repo' };
        dictionary.newBintrayDistributionRepo = { title: 'New Bintray Distribution Repo' };
        return dictionary;
    }

    getActions() {
        let actions = [{
            name: 'newReleaseBundlesRepo',
            icon: 'icon-distribution-repo bordered',
            action: () => {
                this.createNewRepo(REPO_FORM_CONSTANTS.DISTRIBUTION_REPO_TYPES.RELEASE_BUNDLES);
            },
            visibleWhen: () => !this.features.isJCR(),
        }, {
            name: 'newBintrayDistributionRepo',
            icon: 'icon-distribution-repo bordered',
            action: () => {
                this.createNewRepo(REPO_FORM_CONSTANTS.DISTRIBUTION_REPO_TYPES.BINTRAY);
            },
        }];
        if (!this.features.isEnterprisePlus() && !this.features.isJCR()) {
            actions.splice(0,1)
        }

        return actions;
    }
}




// WEBPACK FOOTER //
// ./states/admin/repositories/repositories.controller.js